import { render, staticRenderFns } from "./usrgrids.vue?vue&type=template&id=315f74d2&scoped=true"
import script from "./usrgrids.vue?vue&type=script&lang=js"
export * from "./usrgrids.vue?vue&type=script&lang=js"
import style0 from "./usrgrids.vue?vue&type=style&index=0&id=315f74d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315f74d2",
  null
  
)

export default component.exports